import { isNative } from "./platform";

/**
 * Opens the native photo picker (camera or gallery) on native platforms,
 * or a web file input on the web. Resolves to a File, or null if cancelled.
 */
export async function pickPhoto(): Promise<File | null> {
  if (isNative()) return pickPhotoNative();
  return pickPhotoWeb();
}

async function pickPhotoNative(): Promise<File | null> {
  const { Camera, CameraResultType, CameraSource } = await import("@capacitor/camera");
  try {
    const photo = await Camera.getPhoto({
      quality: 90,
      resultType: CameraResultType.Uri,
      source: CameraSource.Prompt,
    });
    if (!photo.webPath) return null;
    const blob = await (await fetch(photo.webPath)).blob();
    const format = photo.format || "jpeg";
    return new File([blob], `photo.${format}`, { type: `image/${format}` });
  } catch {
    // User cancelled or permission denied.
    return null;
  }
}

function pickPhotoWeb(): Promise<File | null> {
  return new Promise((resolve) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = () => resolve(input.files?.[0] ?? null);
    input.oncancel = () => resolve(null);
    input.click();
  });
}
